import React, { useState, useEffect, useContext } from "react";
import { Card, Radio, Tabs, Modal, Form, Select, Input, message, Tag, Space, Row, Col } from "antd";
import { CloseCircleOutlined, SearchOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { Option } from "antd/lib/mentions";
import "./Tab.css";
import _ from "lodash";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../store/actions/leads";
import { checkAgent, checkPartnerUser, stoageSetter, stoageGetter } from "../../helpers";
import { Button } from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import LeadCard from "../LeadCards/LeadCard";
import GlobalFilters from "./Filter";
import AllocateModalShow from "./Allocate";
import person_black from "./../Activitity Tracker/icons/person_black.png";
import person_white from "./../Activitity Tracker/icons/person_white.png";
import group_white from "./../Activitity Tracker/icons/group_white.png";
import group_black from "./../Activitity Tracker/icons/group_black.png";
import { useLocation } from "react-router-dom";
import axiosRequest from "../../axios-request/request.methods";
// import 'bootstrap/dist/css/bootstrap.min.css';
import Loader from "../Loader/Loader";
// api's
import { getTeamMainTabApi, getFirstDropdownValueApi, getSecondDropdownValueApi, getFormByIdApi, getOpenTabApi, getFortodayTabApi, getDiscardedTabApi, getFailedTabApi } from "../actions/allleadAction";
import { flexibleCompare } from "fullcalendar";
import { Column } from "@antv/g2plot";
import { SyncOutlined, Warning } from "@material-ui/icons";
import { AthenaProductsRouteHandler } from "../../config/product.config";

const { TabPane } = Tabs;

const Tab = ({ tabMenu, test, header, detailsRouteTab, activeKey, activeRenewalkey, current, filterdata, leadDATA, proposalFilter, handleProposalStatusFilter }) => {
  // //console.log("tabMenu*****Data", tabMenu);
  // console.log(activeKey, "activeKey");
  const currentLocation = useLocation();
  const lifeInsuredAge = useSelector((state) => state?.bi?.formData?.lifeInsuredEntryAge);

  // ////console.log("YE ARAR", props)
  // const productCode = useSelector((state)=> state?.productslist?.productlist?.product_code)
  const leadtype = useSelector((state) => state?.leads?.leadType);
  ////console.log("leadType--->",leadtype)
  let ProposarAndLifeInsured = useSelector((state) => state?.proposalDetails?.allProposal?.leadId?.selectPolicyInsuredOption);
  const globalTab = useSelector((state) => state.leads?.globalTab);
  const dispatch = useDispatch();
  const { leadType } = useParams();
  const { masterType } = useParams();
  const [activeTab, setactiveTab] = useState();
  const [showTab, setShowTab] = useState();
  const [showModal, setShowModal] = useState(false);
  const [count, setCount] = useState([]);
  const [proposalNumberSearch, setProposalNumberSearch] = useState("");
  const [filterByStatus, setFilterByStatus] = useState(undefined);
  const location = useLocation();
  //loader
  const [loader, setLoader] = useState(false);
  const [leadDetails, setLeadDetails] = useState({});

  let history = useHistory();
  let _currentTab = "self";
  // const [activeKey, setActiveKey] = useState("self")
  const [currentActiveTab, setCurrentActiveTab] = useState(globalTab === "team" ? "team" : "self");
  const [isDisabled, setIsDisabled] = useState(false);
  const allocateBtnStatus = useSelector((state) => state?.leads?.allocateTab);

  let _leadID = useSelector((state) => state.leads.currentUpdatingID);
  ////console.log("Lead ID------>", _leadID);
  const leadsData = useSelector((state) => state?.leads?.allLeads);
  // //console.log("leadsData===========>", leadsData);

  const leadData = useSelector((state) => state?.newLead);
  // //console.log("leadata===========>", leadData);

  var count1 = useSelector((state) => state?.leads?.countArr);
  const subSource = useSelector((state) => state?.leads?.subSourceArr);
  ////console.log("subSource+++++++++>",subSource)
  var allCount = useSelector((state) => state?.leads?.count);
  //const count_data = useSelector((state) => state?.leads?.countArrSe);

  const userId = useSelector((state) => state?.login?.userId);
  // ////console.log(userId,"ANWB")
  const getleads = useSelector((state) => state.leads.currentActiveTab);

  const _proposalId = useSelector((state) => state.proposalDetails?.allProposal?._id);
  const ProposalTabs = useSelector((state) => state.proposalDetails?.allProposal);
  const policyId = useSelector((state) => state.proposalDetails?.allProposal?.policyId);
  // //console.log("proposal tabs state", ProposalTabs);

  const paymentStatus = useSelector((state) => state.proposalDetails?.allProposal?.paymentOptions?.paymentStatus);
  // ////console.log("~ProposalPAYMNNN",paymentStatus);
  const productCode = useSelector((state) => state.proposalDetails?.allProposal?.productId?.product_code);
  const LeadID = useSelector((state) => state?.needAnalysis?.needAnalysisData?.payload?.leadId);
  // //console.log("LeadID", LeadID);

  const detailsOfPlanData = useSelector((state) => state?.detailsOfPlans?.formData?.BI_PreferredModeofSubsequentPremiumPayment);
  // //console.log("detailsOfPlan===>", detailsOfPlanData);

  const initialEKYCState = useSelector((state) => state?.login?.user?.channelCode?.ekycFlag);
  const proposalTeamUser = useSelector((state) => state.leads.proposalTeamUser);
  const proposalStatus = useSelector((state) => state.proposalDetails?.allProposal?.proposalStatus);
  const userTreeData = useSelector((state) => state?.home?.user_tree);
  const isFetchingRTS = React.useRef(false);
  const [supervisorResetDone, setSupervisorResetDone] = useState(false);


  const login_user_data = stoageGetter("user");

  console.log("dataaaaaaaaa2", login_user_data)

  const isRMmapped = login_user_data?.reportingManager?.employeeCode ? true : false;
  const isRMself = (login_user_data?.reportingManager?.employeeCode === login_user_data?.employeeCode) ? true : false;
  const isSupervisorApprovalFlag = (login_user_data?.channelCode?.supervisorApprovalFlag) ? true : false;

  const isSupervisorApprovalRequired = (isSupervisorApprovalFlag && isRMmapped && !isRMself)

  // //console.log("Initial ekyc-->", initialEKYCState);
  useEffect(() => {
    // if (proposalTeamUser) {
    //   setCurrentActiveTab("team");
    // }
    console.log('proposalTeamUser---------------', proposalTeamUser);

  }, [proposalTeamUser]);

  // Auto-switch to self tab if user is on team tab but has no team members
  useEffect(() => {
    if (currentActiveTab === "team" &&
      header === "Applications" &&
      userTreeData &&
      !(userTreeData?.reporting_users?.length > 0 || userTreeData?.reporting_managers?.length > 0)) {
      handleChangeTab("self");
    }
  }, [userTreeData, currentActiveTab, header]);

  useEffect(() => {
    if (activeKey == "benefitIllustration") {
      return;
    } else if (activeKey == "ApplicationAll") {
      return;
    } else if (activeKey == "oTPAuthentication") {
      return;
    } else {
      //alert("requestnotFound")
      //  ////console.log(userId,"userId")
      try {
        let res = "";
        if (userId && leadtype == "all") {
          res = axiosRequest.get(`user/v2/getleads_team_count/${userId}?requiredData=self`, { secure: true });
          // ////console.log(res);
          res.then((item) => {
            // ////console.log("item===>",item);
            count.push(
              // leadtype == "Self Sourced" ? item?.selfSource ||leadtype == "LSQ" ?  item?.LSQ  : item?.all,
              allCounts(item),
              item?.notinterested,
              item?.open_lead,
              item?.notcontactable,
              item?.wip,
              item?.closed
            );
          });
          // ////console.log(count);
        } else if (userId && leadtype == "LSQ") {
          res = axiosRequest.get(`user/v2/getleads_team_count/${userId}?requiredData=self&leadType=lsqSource`, { secure: true });
          // ////console.log(res);
          res.then((item) => {
            // ////console.log("item===>",item);
            count.push(
              // leadtype == "Self Sourced" ? item?.selfSource ||leadtype == "LSQ" ?  item?.LSQ  : item?.all,
              allCounts(item),
              item?.notinterested,
              item?.open_lead,
              item?.notcontactable,
              item?.wip,
              item?.closed
            );
          });
        } else if (userId && leadtype == "Self Sourced") {
          res = axiosRequest.get(`user/v2/getleads_team_count/${userId}?requiredData=self&leadType=selfSourced`, { secure: true });
          // ////console.log(res);
          res.then((item) => {
            // ////console.log("item===>",item);
            count.push(
              // leadtype == "Self Sourced" ? item?.selfSource ||leadtype == "LSQ" ?  item?.LSQ  : item?.all,
              allCounts(item),
              item?.notinterested,
              item?.open_lead,
              item?.notcontactable,
              item?.wip,
              item?.closed
            );
          });
        }
      } catch (error) {
        // ////console.log(error,"Helooo");
      }
    }

    const data = leadsData?.find((item) => item.id === _leadID);
    ////console.log("data------->", data);
    if (data) {
      setLeadDetails(data);
    }
  }, [currentActiveTab, _leadID, leadsData]);
  const get_live_rts_data = async (e) => {
    if (e?.stopPropagation) {
      e.stopPropagation();
      e.preventDefault();
    }
    if (isFetchingRTS.current) return;
    isFetchingRTS.current = true;

    try {
      setLoader(true);
      await axiosRequest.get("user/rts_live_update");
    } catch (error) {
      console.error("RTS Update Error", error);
    } finally {
      setLoader(false);
      isFetchingRTS.current = false;
    }
  };

  const handleClearProposalNumber = () => {
    setProposalNumberSearch("");
    proposalFilter("");
  };

  const handleProposalNumber = (value) => {
    setProposalNumberSearch(value);
    if (value === "") {
      proposalFilter("");
    }
  };

  const handleSearchProposalNumber = () => {
    //console.log("search param", proposalNumberSearch);
    proposalFilter(proposalNumberSearch);
  };

  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  const suffix = (
    <>
      {proposalNumberSearch && <CloseCircleOutlined onClick={handleClearProposalNumber} style={{ marginRight: 8, cursor: "pointer" }} />}
      <SearchOutlined onClick={handleSearchProposalNumber} style={{ cursor: "pointer" }} />
    </>
  );

  const allCounts = (counts) => {
    // ////console.log("counts===>",counts)
    if (leadtype == "Self Sourced") {
      return counts?.selfSource;
    } else if (leadtype == "all") {
      return counts?.all;
    } else if (leadtype == "LSQ") {
      return counts?.LSQ;
    }
  };

  useEffect(() => {
    const kycRequiredTabs = [
      "uploaddocuments",
      "uploaddynamicdocuments",
      "supervisorApproval",
      "ProposalFormFilling",
      "oTPAuthentication",
      "payments",
      "esir",
      "finalSubmit"
    ];

    if (kycRequiredTabs.includes(activeKey) && globalTab !== "team") {
      const leadData = ProposalTabs?.leadId;
      if (ProposalTabs?._id && leadData && leadData?.isKycStageCompleted !== true) {
        message.warn("Please complete KYC authentication before proceeding.");
        history.push("/kyc-details");
      }
    }
  }, [activeKey, ProposalTabs?._id, ProposalTabs?.leadId?.isKycStageCompleted, globalTab, history]);

  useEffect(() => {
    // ////console.log('************************ LEADDD ___ *********************===========>>>',leadsData)
    // ////console.log("______________location_______________",location)
    dispatch({ type: "CURRENT_UPDATING_TAB", action: "all" });
    if (header === "Lead" && leadtype == "Self Sourced") {
      dispatch(actions.fetchLeadType(""));
    } else {
      getDataForOpen("all");
    }

    // if (currentActiveTab === "self") {
    // const { id } = stoageGetter("user");
    // dispatch(actions.fetchAllLeads(id, 'all', 1));
    // getDataForOpen('all')
    // }
    // }
  }, []);
  // const ids = stoageGetter('user')

  // ************************Api *********************

  const getDataForOpen = async (leadInc) => {
    // let leadtyp = leadInc;
    const { id } = stoageGetter("user");
    const teamId = stoageGetter("teamMemberId");

    if (leadtype === "self sourced") {
      dispatch(actions.fetchAllLeads(id, leadInc, 1, LeadID));
    }
    if (leadtype === "all") {
      dispatch(actions.fetchAllLeads(id, leadInc, 1, LeadID));
    }

    if (leadtype === "LSQ") {
      dispatch(actions.fetchAllLeads(id, leadInc, 1, LeadID)).then((res) => {
      });
    }
    if (leadsData.globalTab === "team") {
      dispatch(actions.fetchAllLeads(teamId, leadInc, 1, LeadID));
    }

    // const response = await getOpenTabApi(id, leadInc);
    // if (response?.data?.errCode == -1) {
    //   if (response?.data?.errMsg) {
    //   dispatch(
    //       actions.fetchAllLeadsSuccess(
    //         response?.data?.errMsg[0],
    //    response?.data?.errMsg[1][0]?.count

    //       )
    // );
    //   }
    // } else {
    //   dispatch(actions.fetchAllLeadsSuccess([], 0));
    //   throw response?.data?.errMsg;
    // }
  };

  const switchteamself = async (leadInc, event) => {
    // let leadtyp = leadInc;
    ////console.log("Team Self Switch");
    // count1 = 0
    let item = {
      all_lead: "0",
      notinterested: "0",
      open_lead: "0",
      notcontactable: "0",
      wip: "0",
      closed: "0",
    };

    let count = [];
    // let countT = []

    count.push(item?.all_lead, item?.notinterested, item?.open_lead, item?.notcontactable, item?.wip, item?.closed);
    console.warn("This is total Counts ----> ", count);
    // countT.push()
    //if (leadsData?.globalTab === 'team') {
    dispatch(actions.addAllTeamCount(count));

    const { id } = stoageGetter("user");
    const teamId = stoageGetter("teamMemberId");

    if (event === "self") {
      dispatch(actions.fetchAllLeads(id, leadInc, 1, LeadID));
      getDataForOpen(leadInc);
    }

    if (event === "team") {
      dispatch(actions.fetchAllLeads(teamId, "all", 1, LeadID));
    }
  };

  // const getAlldataofTeamMainTab = async () => {
  //   const response = await getTeamMainTabApi();
  //   if (response?.data?.errCode == -1) {
  //     if (response?.data?.errMsg) {
  //       // setAllData(response?.data?.errMsg[0])
  //       dispatch(
  //         actions.fetchAllLeadsSuccess(
  //           response?.data?.errMsg[0],
  //           response?.data?.errMsg[1][0]?.count
  //         )
  //       );
  //     }
  //   } else {
  //     dispatch(actions.fetchAllLeadsSuccess([], 0));
  //     throw response?.data?.errMsg;
  //     // dispatch(fetchAllLeadsFail(error))
  //   }
  //   // const response2 = await getFirstDropdownValueApi()
  //   // const response3 = await getSecondDropdownValueApi()
  //   // const response4 = await getFormByIdApi("")
  //   // ////console.log("response",response)
  //   // ////console.log("response2",response2)
  //   // ////console.log("response3",response3)
  //   // ////console.log("response4",response4)
  // };

  const handleChangeTab = (currentTab) => {

    console.log('currentTab------', currentTab);

    _currentTab = currentTab;
    setCurrentActiveTab(currentTab);
    switchteamself(getleads, currentTab);

    dispatch(actions.updateTabOfDashboard(currentTab));
    if (currentTab === "team") {
      dispatch(actions.proposalTeamSelect(false));
      dispatch(actions.showProposalTable(false));
    } else {
      dispatch(actions.proposalTeamSelect(true));
      dispatch(actions.showProposalTable(true));
      dispatch(actions.selectedFilterBy("mtd"));
      dispatch(actions.proposalTeamData({}));
      stoageSetter("teamMemberId", '');
      stoageSetter("hierarchyId", '');
      setFilterByStatus(undefined)
    }
    // if (currentTab === "team") getDataForOpen();
    currentTab !== currentActiveTab && dispatch(actions.updateAllocateOfOpportunities(false));
  };

  //********************************API Integration for check lead delete*****************************//

  const checkLeadDelete = async () => {
    const leadID = leadData?.formData?.lead_Id;
    //console.log("testing------>");
    return await axiosRequest
      .get(`user/getLeadCheck/${leadID}`)
      .then((res) => {
        //console.log("res", res);
        if (res?.errCode == 539) {
          // Returning null as a resolved promise value
          return res;
        }
      })
      .catch((err) => {
        //console.log("err", err);
        // Re-throwing the error to propagate it further
        throw err;
      });
  };

  // -****************************************
  function hasEmptyUploads(documentUpload) {
    if (!Array.isArray(documentUpload) || documentUpload.length === 0) return true;

    const uploadFields = documentUpload[0]; // Assuming it's always an array with a single object
    for (const key in uploadFields) {
      if (Array.isArray(uploadFields[key]) && uploadFields[key].length === 0) {
        return true; // Found an empty array
      }
    }

    return false; // All fields have non-empty arrays
  }
  const isDynamicDocumentUpload = () => {
    if (ProposalTabs?.nameScoreStatus === "Failed") {
      // Check if Dynamic_doc exists and is an array
      if (!Array.isArray(ProposalTabs?.Dynamic_doc)) {
        // return utils.sendResponse(req, res, 200, 256, "Dynamic documents data is invalid");
        return true;
      }
      // Check if any document has document_sub_type as "Cheque Copy"
      const hasChequeCopy = ProposalTabs?.Dynamic_doc.some((doc) => doc && doc.document_sub_type === "Cheque Copy");
      // user not moved to otp verification when penny drop failed then cheque required
      if (!hasChequeCopy) {
        return true;
      }
      return false;
    }
  };

  useEffect(() => {
    if (ProposalTabs?._id && ProposalTabs?.supervisorApproval?.status === "Pending") {
      sessionStorage.removeItem(`supervisorReset_${ProposalTabs?._id}`);
    }
  }, [ProposalTabs?._id, ProposalTabs?.supervisorApproval?.status]);

  const shouldResetSupervisorApproval = () => {
    console.log(
      "Checking if Supervisor Approval reset is needed...",
      ProposalTabs?.supervisorApproval
    );

    const resetStatus = sessionStorage.getItem(`supervisorReset_${ProposalTabs?._id}`);

    return (
      !supervisorResetDone &&
      resetStatus !== ProposalTabs?.supervisorApproval?.status &&
      ["Approved", "Reconsidered"].includes(
        ProposalTabs?.supervisorApproval?.status
      )
    );
  };

  const handleSupervisorApprovalReset = (navigateCallback) => {
    Modal.confirm({
      title: "Supervisor Approval",
      content:
        "You will have to take approval from your Supervisor again. Do you want to proceed?",
      okText: "Yes",
      cancelText: "No",
      centered: true,
      onOk: async () => {
        try {
          setLoader(true);

          await axiosRequest.post(
            "user/resetSupervisorApproval",
            {
              proposalId: ProposalTabs?._id,
            }
          );

          setSupervisorResetDone(true);
          if (ProposalTabs?._id && ProposalTabs?.supervisorApproval?.status) {
            sessionStorage.setItem(`supervisorReset_${ProposalTabs?._id}`, ProposalTabs?.supervisorApproval?.status);
          }

          navigateCallback();
        } catch (error) {
          console.error(error);
          message.error("Failed to reset Supervisor Approval");
        } finally {
          setLoader(false);
        }
      },
    });
  };


  const handler = async (activeKey) => {
    setactiveTab(activeKey);

    dispatch({ type: "CURRENT_UPDATING_TAB", action: activeKey });

    const backNavigationTabs = [
      "benefitIllustrator",
      "kycDetails",
      "uploaddocuments",
      "ProposalFormFilling",
      "uploaddynamicdocuments",
    ];

    const isBackNavigation =
      backNavigationTabs.includes(activeKey);

    const isSupervisorApproved =
      shouldResetSupervisorApproval();

    const alreadyResetSupervisorApproval = 
      sessionStorage.getItem(`supervisorReset_${ProposalTabs?._id}`) === ProposalTabs?.supervisorApproval?.status &&
      ["Approved", "Reconsidered"].includes(ProposalTabs?.supervisorApproval?.status);

    // console.log("active key tab", activeKey);
    if (activeKey) {
      switch (activeKey) {
        case "all": {
          if (leadtype == "Self Sourced") {
            dispatch(actions.fetchLeadType(""));
          } else if (leadtype == "LSQ") {
            dispatch(actions.fetchLeadType(""));
          }
          getDataForOpen("all");
          return history.push("/leadMaster/all_leads");
        }
        case "notinterested": {
          getDataForOpen("notinterested");
          return history.push("/leadMaster/notInterested");
        }
        case "open": {
          getDataForOpen("open");
          return history.push("/leadMaster/openlead");
        }

        case "notcontactable": {
          getDataForOpen("notcontactable");
          return history.push("/leadMaster/notContactable");
        }

        case "wip": {
          getDataForOpen("wip");
          return history.push("/leadMaster/wip");
        }
        case "closed": {
          getDataForOpen("closed");
          return history.push("/leadMaster/closed");
        }

        case "1":
          localStorage.setItem("Current_Updating_Lead", "");
          return history.push("/leadmasterpage/statuslead");
        // case '2':
        //   return history.push('/leadmasterpage/leaddetails/personallead')
        // case '3':
        //   return history.push('/leadmasterpage/proposal')
        // case '4':
        //   return history.push('/leadmasterpage/leadmasterdoc/leaddoc')
        case "2":
          ////console.log("Checking------->", leadData);
          if (_leadID) {
            if (_leadID && leadData?.formData?.leadSource?.name !== "LSQ" && initialEKYCState == true && leadData?.formData?.EKYCStatus == true) {
              //console.log("Testing self sourced and ekyc issue and going from here----->");
              checkLeadDelete()
                .then((res) => {
                  //console.log("response--->", res);
                  if (res?.errCode == 539) {
                    if (res?.errMsg === "Lead is Present") {
                      //console.log("Testing------------------------------>lead delete");
                      history.push("/leadmasterpage/leaddetails/personallead");
                      return;
                    } else {
                      message.warning(res?.errMsg);
                      return history.push("/leadMaster/all_leads");
                      // return;
                    }
                  }
                })
                .catch((error) => {
                  // Handle error if necessary
                  //console.log("error---->", error);
                  return;
                });

              return;
              // history.push("/leadmasterpage/leaddetails/personallead");
              // return;
            } else if (_leadID && leadData?.formData?.leadSource?.name == "Self Sourced") {
              if (initialEKYCState == true && leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false) {
                //console.log("Testing self sourced and ekyc issue----->");
                message.warning("Please proceed with.");
                return;
              } else {
                //console.log("Testing self sourced and ekyc issue and going ----->");
                // checkLeadDelete();
                checkLeadDelete()
                  .then((res) => {
                    //console.log("response--->", res);
                    if (res?.errCode == 539) {
                      if (res?.errMsg === "Lead is Present") {
                        //console.log("Testing------------------------------>lead delete");
                        history.push("/leadmasterpage/leaddetails/personallead");
                        return;
                      } else {
                        message.warning(res?.errMsg);
                        return history.push("/leadMaster/all_leads");
                        // return;
                      }
                    }
                  })
                  .catch((error) => {
                    // Handle error if necessary
                    //console.log("error---->", error);
                    return;
                  });

                return;
                // history.push("/leadmasterpage/leaddetails/personallead");
                // return;
              }
            } else if (_leadID && leadData?.formData?.leadSource?.name == "LSQ") {
              if (leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false && initialEKYCState == false && leadData?.formData?.ckycStatus == false) {
                //console.log("Checking LSQ-------> personal lead");

                message.warning("Please proceed with or without EKYC.");
                return;
              } else if (_leadID && leadData?.formData?.leadSource?.name == "LSQ" && initialEKYCState == true && leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false && leadData?.formData?.ckycStatus == false) {
                message.warning("Please proceed with EKYC.");
                return;
              } else {
                checkLeadDelete()
                  .then((res) => {
                    //console.log("response--->", res);
                    if (res?.errCode == 539) {
                      if (res?.errMsg === "Lead is Present") {
                        //console.log("Testing------------------------------>lead delete");
                        history.push("/leadmasterpage/leaddetails/personallead");
                        return;
                      } else {
                        message.warning(res?.errMsg);
                        return history.push("/leadMaster/all_leads");
                        // return;
                      }
                    }
                  })
                  .catch((error) => {
                    // Handle error if necessary
                    //console.log("error---->", error);
                    return;
                  });

                return;
                // checkLeadDelete();
                // history.push("/leadmasterpage/leaddetails/personallead");
                // return;
              }
            } else {
              message.warning("Please create the Lead to move forward");
              return;

              // return;
            }
            // return;
          }
        // case "3": should be at last
        //   return history.push("/leadmasterpage/leadhistory");
        case "3":
          //console.log("Checking------->", leadData);
          if (_leadID) {
            if (_leadID && leadData?.formData?.leadSource?.name == "Self Sourced" && initialEKYCState == true && (leadData?.formData?.EKYCStatus == true || (leadData?.formData?.WOEKYCStatus == true && leadData?.formData?.ckycStatus == false))) {
              checkLeadDelete()
                .then((res) => {
                  //console.log("response--->", res);
                  if (res?.errCode == 539) {
                    if (res?.errMsg === "Lead is Present") {
                      //console.log("Testing------------------------------>lead delete");
                      history.push("/leadmasterpage/needanalysis/needanalysis");
                      return;
                    } else {
                      message.warning(res?.errMsg);
                      return history.push("/leadMaster/all_leads");
                      // return;
                    }
                  }
                })
                .catch((error) => {
                  // Handle error if necessary
                  //console.log("error---->", error);
                  return;
                });

              return;
              // return history.push("/leadmasterpage/needanalysis/needanalysis");
            } else if (_leadID && leadData?.formData?.leadSource?.name == "Self Sourced") {
              if (initialEKYCState == true && leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false && leadData?.formData?.ckycStatus == false) {
                //console.log("Testing self sourced and ekyc issue----->");
                message.warning("Please proceed with EKYC.");
                return;
              } else {
                checkLeadDelete()
                  .then((res) => {
                    //console.log("response--->", res);
                    if (res?.errCode == 539) {
                      if (res?.errMsg == "Lead is Present") {
                        history.push("/leadmasterpage/needanalysis/needanalysis");
                        return;
                      } else {
                        message.warning(res?.errMsg);
                        return history.push("/leadMaster/all_leads");
                        // return
                      }
                    }
                  })
                  .catch((error) => {
                    // Handle error if necessary
                    //console.log("error---->", error);
                    return;
                  });
                //console.log("Testing self sourced and ekyc issue and going ----->");
                // history.push("/leadmasterpage/needanalysis/needanalysis");
                return;
              }
            } else if (_leadID && leadData?.formData?.leadSource?.name == "LSQ") {
              if (leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false && initialEKYCState == false && leadData?.formData?.ckycStatus == false) {
                //console.log("Checking LSQ-------> need analysis");

                message.warning("Please preceed with or without EKYC.");
                return;
              } else if (_leadID && leadData?.formData?.leadSource?.name == "LSQ" && initialEKYCState == true && leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false && leadData?.formData?.ckycStatus == false) {
                message.warning("Please proceed with EKYC.");
                return;
              } else {
                checkLeadDelete()
                  .then((res) => {
                    //console.log("response--->", res);
                    if (res?.errCode == 539) {
                      if (res?.errMsg == "Lead is Present") {
                        history.push("/leadmasterpage/needanalysis/needanalysis");
                        return;
                      } else {
                        message.warning(res?.errMsg);
                        return history.push("/leadMaster/all_leads");
                        // return
                      }
                    }
                  })
                  .catch((error) => {
                    // Handle error if necessary
                    //console.log("error---->", error);
                    return;
                  });
                //console.log("Testing------------------------------>lead deleteOne");
                // history.push("/leadmasterpage/needanalysis/needanalysis");
                return;
              }
            } else {
              message.warning("Please create the Lead to move forward");
              return;
            }
            // return;
          }

        case "4":
          if (_leadID) {
            if (_leadID && leadData?.formData?.leadSource?.name == "Self Sourced" && initialEKYCState == true && leadData?.formData?.EKYCStatus == true) {
              checkLeadDelete()
                .then((res) => {
                  //console.log("response--->", res);
                  if (res?.errCode == 539) {
                    if (res?.errMsg == "Lead is Present") {
                      history.push("/leadmasterpage/leadtracker");
                      return;
                    } else {
                      message.warning(res?.errMsg);
                      return history.push("/leadMaster/all_leads");
                      // return;
                    }
                  }
                })
                .catch((error) => {
                  // Handle error if necessary
                  //console.log("error---->", error);
                  return;
                });
              return;
            } else if (_leadID && leadData?.formData?.leadSource?.name == "Self Sourced") {
              if (initialEKYCState == true && leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false) {
                // //console.log("Testing self sourced and ekyc issue----->");
                // message.warning("Please proceed with EKYC.");
                // return;
                checkLeadDelete()
                  .then((res) => {
                    //console.log("response--->", res);
                    if (res?.errCode == 539) {
                      if (res?.errMsg == "Lead is Present") {
                        history.push("/leadmasterpage/leadtracker");
                        return;
                      } else {
                        message.warning(res?.errMsg);
                        return history.push("/leadMaster/all_leads");
                        // return;
                      }
                    }
                  })
                  .catch((error) => {
                    // Handle error if necessary
                    //console.log("error---->", error);
                    return;
                  });
                return;
              } else {
                checkLeadDelete()
                  .then((res) => {
                    //console.log("response--->", res);
                    if (res?.errCode == 539) {
                      if (res?.errMsg == "Lead is Present") {
                        history.push("/leadmasterpage/leadtracker");
                        return;
                      } else {
                        message.warning(res?.errMsg);
                        return history.push("/leadMaster/all_leads");
                        // return;
                      }
                    }
                  })
                  .catch((error) => {
                    // Handle error if necessary
                    //console.log("error---->", error);
                    return;
                  });
                return;
              }
            } else if (_leadID && leadData?.formData?.leadSource?.name == "LSQ") {
              if (leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false && initialEKYCState == false) {
                //console.log("Checking LSQ------->");

                message.warning("Please proceed with or without EKYC.");
                return;
              } else if (_leadID && leadData?.formData?.leadSource?.name == "LSQ" && initialEKYCState == true && leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false) {
                message.warning("Please proceed with EKYC.");
                return;
              } else {
                checkLeadDelete()
                  .then((res) => {
                    //console.log("response--->", res);
                    if (res?.errCode == 539) {
                      if (res?.errMsg == "Lead is Present") {
                        history.push("/leadmasterpage/leadtracker");
                        return;
                      } else {
                        message.warning(res?.errMsg);
                        return history.push("/leadMaster/all_leads");
                        // return;
                      }
                    }
                  })
                  .catch((error) => {
                    // Handle error if necessary
                    //console.log("error---->", error);
                    return;
                  });
                return;
              }
            } else {
              message.warning("Please create the Lead to move forward");
              return;
            }
            // return;
          }

        // case "5":
        //   if (_leadID) {
        //     if (_leadID && leadData?.formData?.leadSource?.name == "Self Sourced" && initialEKYCState ==true &&leadData?.formData?.EKYCStatus
        //     == true) {
        //       return history.push("/leadmasterpage/leadhistory");
        //     }else if(_leadID && leadData?.formData?.leadSource?.name == "Self Sourced"){
        //       if( initialEKYCState ==true &&leadData?.formData?.EKYCStatus
        //         == false){
        //           //console.log("Testing self sourced and ekyc issue----->")
        //         message.warning("Please proceed with EKYC.");
        //         return;
        //       }else{
        //         //console.log("Testing self sourced and ekyc issue and going ----->")
        //         history.push("/leadmasterpage/leaddetails/personallead");
        //         return;
        //       }
        //     } else if (_leadID && leadData?.formData?.leadSource?.name == "LSQ") {
        //       if (leadData?.formData?.EKYCStatus == false && leadData?.formData?.WOEKYCStatus == false  && initialEKYCState == false) {
        //         //console.log("Checking LSQ------->");

        //         message.warning("Please proceed with or without EKYC.");
        //         return;
        //       }else if(_leadID && leadData?.formData?.leadSource?.name == "LSQ"&& initialEKYCState ==true &&leadData?.formData?.EKYCStatus
        //       == false){
        //         message.warning("Please proceed with EKYC.");
        //         return;
        //     }  else {
        //         history.push("/leadmasterpage/leadhistory");
        //         return;
        //       }
        //     } else {
        //       message.warning("Please create the Lead to move forward");
        //       return;
        //     }
        //     return;
        //   }

        // case "6":
        //   if (_leadID) {

        //   } else {
        //     message.warning("Please create the Lead to move forward");
        //     return;
        //   }

        // case "calendar":
        //   return history.push("/calendar");

        // case "todo":
        //   return history.push("/todo");

        // case "advisorpitch":
        //   return history.push("/masterpresales/advisordetail/advisorpitch");

        case "CustomerReview":
          return history.push("/customer_review");
        case "successDrawer":
          return history.push("/success");

        case "proposalLogin": {
          return history.push("/proposalLoginReport");
        }

        case "sessionReportLogin": {
          return history.push("/sessionReportLogin");
        }

        // case "allrenewals":
        //   return history.push("/renewalMaster/allRenewals");
        // case "paidrenewals":
        //   return history.push("/renewalMaster/paidRenewals");
        // case "unpaidrenewals":
        //   return history.push("/renewalMaster/unpaidRenewals");
        // case "lapsedrenewals":
        //   return history.push("/renewalMaster/lapsedRenewals");
        case "benefitIllustrator":
          // In team view, allow navigation regardless of status
          if (globalTab === "team") {
            AthenaProductsRouteHandler(history, productCode);
            return;
          }

          // Allow navigation from KYC Details to Benefit Illustrator without restrictions
          if (currentLocation.pathname === "/kyc-details") {
            AthenaProductsRouteHandler(history, productCode);
            return;
          }

          if (currentLocation.pathname.startsWith("/uploaddoc/")) {
            AthenaProductsRouteHandler(history, productCode);
            return;
          }
          // Allow navigation from Proposal Form Filling to Benefit Illustrator without restrictions
          if (currentLocation.pathname.startsWith("/proposalFormFilling/")) {
            AthenaProductsRouteHandler(history, productCode);
            return;
          }

          if (currentLocation.pathname.startsWith("/uploaddynamicdoc/")) {
            AthenaProductsRouteHandler(history, productCode);
            return;
          }

          if (isBackNavigation && isSupervisorApproved) {
            return handleSupervisorApprovalReset(() =>
              AthenaProductsRouteHandler(history, productCode)
            );
          }
          if (isBackNavigation && alreadyResetSupervisorApproval) {
            return AthenaProductsRouteHandler(history, productCode);
          }

          if (currentLocation.pathname.startsWith("/otpauthentication")) {
            AthenaProductsRouteHandler(history, productCode);
            return;
          }


          if (ProposalTabs?.proposalStatus === "Login successful - Login Successful") {
            message.warning("Login for this proposal is successfully completed. Returning to previous tab is no longer available.");
            return;
          } else if (ProposalTabs?.proposalStatus === "Supervisor Approval Pending" && ProposalTabs?.supervisorApproval?.status !== "Reconsidered") {
            if (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") {
              return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
            }
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (paymentStatus == "SUCCESS") {
            message.warning("Payment for this proposal is sucessfuly completed. Returning to previous tab is no longer available.");
            return;
          } else if (ProposalTabs?.OTPAuthStatus === "SUCCESS") {
            return message.warning("OTP Authentication for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else {
            AthenaProductsRouteHandler(history, productCode);
          }

        case "kycDetails":
          // In team view, allow navigation regardless of status
          if (globalTab === "team") {
            return history.push("/kyc-details");
          }
          if (isBackNavigation && isSupervisorApproved) {
            return handleSupervisorApprovalReset(() =>
              history.push("/kyc-details")
            );
          }
          if (isBackNavigation && alreadyResetSupervisorApproval) {
            return history.push("/kyc-details");
          }

          if (ProposalTabs?.proposalStatus === "Login successful - Login Successful") {
            message.warning("Login for this proposal is successfully completed. Returning to previous tab is no longer available.");
            return;
          } else if (ProposalTabs?.proposalStatus === "Supervisor Approval Pending" && ProposalTabs?.supervisorApproval?.status !== "Reconsidered") {
            if (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") {
              return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
            }
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (paymentStatus == "SUCCESS") {
            message.warning("Payment for this proposal is sucessfuly completed. Returning to previous tab is no longer available.");
            return;
          } else if (ProposalTabs?.OTPAuthStatus === "SUCCESS") {
            return message.warning("OTP Authentication for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (Object.keys(ProposalTabs).length === 0) {
            return message.warning("Proposal is submitted. Kindly generate new BI.");
          } else if (!_proposalId) {
            return message.warning("Please Generate BI");
          } else if (ProposalTabs?.regenerateBi || !ProposalTabs?.biDisabled) {
            return message.warning("Please generate BI to proceed further.");
          } else {
            return history.push("/kyc-details");
          }

        case "payments":
          // In team view, allow navigation regardless of status
          if (globalTab === "team") {
            return history.push("/payments");
          }

          if (ProposalTabs?.proposalStatus === "Login successful - Login Successful") {
            return message.warning("Login for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (Object.keys(ProposalTabs).length === 0) {
            return message.warning("Proposal is submitted. Kindly generate new BI.");
          } else if (!_proposalId) {
            return message.warning("Please Generate BI");
          } else if (ProposalTabs?.regenerateBi || !ProposalTabs?.biDisabled) {
            return message.warning("Please generate BI to proceed further.");
          } else if (!ProposalTabs?.leadId?.isKycStageCompleted) {
            return message.warning("Please complete KYC to proceed further.");
          } else if (ProposalTabs?.proposalStatus === "Supervisor Approval Pending") {
            if (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") {
              return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
            }
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (hasEmptyUploads(ProposalTabs?.documentUpload)) {
            return message.warning("Please upload the Mandatory Docs");
          } else if (ProposalTabs?.elinsuranceAccountDetails == undefined) {
            return message.warning("Please fill the Proposal Form - EInsurance and click on Next");
          } else if (ProposalTabs?.AboutCustomer == undefined) {
            return message.warning("Please fill the Proposal Form - About Customer and click on Next");
          } else if (lifeInsuredAge > 18 && ProposalTabs?.FinancialDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Financial Details and click on Next");
          } else if (ProposalTabs?.HealthDetailsSection.customerHeight === undefined || ProposalTabs?.HealthDetailsSection.customerHeight === "") {
            return message.warning("Please fill the Proposal Form - Health Details and click on Next");
          } else if (ProposalTabs?.PreviousPolicyDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Previous Policy Details and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === true && !ProposalTabs?.NominationDetails?.NomineeName) {
            return message.warning("Please fill the Proposal Form - Nomination Details and click on Next");
          } else if (ProposalTabs?.Declaration?.AlchoholQuestionaire === "") {
            return message.warning("Please fill the Proposal Form - Declaration and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === false && !ProposalTabs?.ProposerDetails === undefined) {
            return message.warning("Please fill the Proposal Form - Proposer Details and click on Next");
          } else if (ProposalTabs?.proposalStatus === "Login WIP - Proposal Draft") {
            if (isSupervisorApprovalRequired) {
              return message.warning("Please complete the All Proposal Form to proceed for Supervisor Approval");
            } else {
              return message.warning("Please complete the All Proposal Form to proceed for OTP Authentication");
            }
          } else if (isSupervisorApprovalRequired && (!ProposalTabs?.supervisorApproval || (ProposalTabs?.supervisorApproval?.status !== "Approved" && ProposalTabs?.supervisorApproval?.status !== "approved"))) {
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (isSupervisorApprovalRequired && (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") && !["Login WIP - OTP Authentication pending", "OTP Authentication Pending", "Pending OTP", "Login WIP - Payment Pending", "Payment Pending", "Login WIP - Mandate Pending", "Login WIP - e-SIR Pending", "e-SIR Pending"].includes(ProposalTabs?.proposalStatus)) {
            return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
          } else if (ProposalTabs?.OTPAuthStatus !== "SUCCESS") {
            return message.warning("Please complete OTP Authentication");
          } else if (paymentStatus == "SUCCESS") {
            return message.warning("Payment for this proposal is sucessfuly completed. Returning to previous tab is no longer available.");
          } else {
            return history.push("/payments");
          }

        case "esir":
          // In team view, allow navigation regardless of status
          if (globalTab === "team") {
            if (ProposalTabs?.subsequentPaymentMode === "enach") {
              let result = await axiosRequest.get(`user/enachCheck/${ProposalTabs._id}`);
              if (result?.proceedESIR === true) {
                return history.push("/esir");
              } else {
                return;
              }
            } else {
              return history.push("/esir");
            }
          }

          if (ProposalTabs?.proposalStatus === "Login successful - Login Successful") {
            return message.warning("Login for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (Object.keys(ProposalTabs).length === 0) {
            return message.warning("Proposal is submitted. Kindly generate new BI.");
          } else if (!_proposalId) {
            return message.warning("Please Generate BI");
          } else if (ProposalTabs?.regenerateBi || !ProposalTabs?.biDisabled) {
            return message.warning("Please generate BI to proceed further.");
          } else if (!ProposalTabs?.leadId?.isKycStageCompleted) {
            return message.warning("Please complete KYC to proceed further.");
          } else if (ProposalTabs?.proposalStatus === "Supervisor Approval Pending") {
            if (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") {
              return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
            }
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (hasEmptyUploads(ProposalTabs?.documentUpload)) {
            return message.warning("Please upload the Mandatory Docs");
          } else if (ProposalTabs?.elinsuranceAccountDetails == undefined) {
            return message.warning("Please fill the Proposal Form - EInsurance and click on Next");
          } else if (ProposalTabs?.AboutCustomer == undefined) {
            return message.warning("Please fill the Proposal Form - About Customer and click on Next");
          } else if (lifeInsuredAge > 18 && ProposalTabs?.FinancialDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Financial Details and click on Next");
          } else if (ProposalTabs?.HealthDetailsSection.customerHeight === undefined || ProposalTabs?.HealthDetailsSection.customerHeight === "") {
            return message.warning("Please fill the Proposal Form - Health Details and click on Next");
          } else if (ProposalTabs?.PreviousPolicyDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Previous Policy Details and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === true && !ProposalTabs?.NominationDetails?.NomineeName) {
            return message.warning("Please fill the Proposal Form - Nomination Details and click on Next");
          } else if (ProposalTabs?.Declaration?.AlchoholQuestionaire === "") {
            return message.warning("Please fill the Proposal Form - Declaration and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === false && !ProposalTabs?.ProposerDetails) {
            return message.warning("Please fill the Proposal Form - Proposer Details and click on Next");
          } else if (ProposalTabs?.proposalStatus === "Login WIP - Proposal Draft") {
            if (isSupervisorApprovalRequired) {
              return message.warning("Please complete the All Proposal Form to proceed for Supervisor Approval");
            } else {
              return message.warning("Please complete the All Proposal Form to proceed for OTP Authentication");
            }
          } else if (isSupervisorApprovalRequired && (!ProposalTabs?.supervisorApproval || (ProposalTabs?.supervisorApproval?.status !== "Approved" && ProposalTabs?.supervisorApproval?.status !== "approved"))) {
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (isSupervisorApprovalRequired && (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") && !["Login WIP - OTP Authentication pending", "OTP Authentication Pending", "Pending OTP", "Login WIP - Payment Pending", "Payment Pending", "Login WIP - Mandate Pending", "Login WIP - e-SIR Pending", "e-SIR Pending"].includes(ProposalTabs?.proposalStatus)) {
            return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
          } else if (ProposalTabs?.OTPAuthStatus !== "SUCCESS") {
            return message.warning("Please complete OTP Authentication");
          } else if (ProposalTabs?.paymentOptions?.paymentStatus == "PENDING") {
            return message.warning("Payment is Pending");
          } else if (ProposalTabs?.mandateStatus === "NA") {
            return message.warning("Mandate is Pending");
          } else {
            if (ProposalTabs?.subsequentPaymentMode === "enach") {
              let result = await axiosRequest.get(`user/enachCheck/${ProposalTabs._id}`);

              //console.log("check enach statsus", result);
              if (result?.proceedESIR === true) {
                return history.push("/esir");
              } else {
                return;
              }
            } else {
              return history.push("/esir");
            }
          }

        case "finalSubmit":
          if (Object.keys(ProposalTabs).length === 0) {
            return message.warning("Proposal is submitted. Kindly generate new BI.");
          } else if (!_proposalId) {
            return message.warning("Please Generate BI");
          } else if (ProposalTabs?.regenerateBi || !ProposalTabs?.biDisabled) {
            return message.warning("Please generate BI to proceed further.");
          } else if (!ProposalTabs?.leadId?.isKycStageCompleted) {
            return message.warning("Please complete KYC to proceed further.");
          } else if (ProposalTabs?.proposalStatus === "Supervisor Approval Pending") {
            if (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") {
              return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
            }
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (hasEmptyUploads(ProposalTabs?.documentUpload)) {
            return message.warning("Please upload the Mandatory Docs");
          } else if (ProposalTabs?.elinsuranceAccountDetails == undefined) {
            return message.warning("Please fill the Proposal Form - EInsurance and click on Next");
          } else if (ProposalTabs?.AboutCustomer == undefined) {
            return message.warning("Please fill the Proposal Form - About Customer and click on Next");
          } else if (lifeInsuredAge > 18 && ProposalTabs?.FinancialDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Financial Details and click on Next");
          } else if (ProposalTabs?.HealthDetailsSection.customerHeight === undefined || ProposalTabs?.HealthDetailsSection.customerHeight === "") {
            return message.warning("Please fill the Proposal Form - Health Details and click on Next");
          } else if (ProposalTabs?.PreviousPolicyDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Previous Policy Details and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === true && !ProposalTabs?.NominationDetails?.NomineeName) {
            return message.warning("Please fill the Proposal Form - Nomination Details and click on Next");
          } else if (ProposalTabs?.Declaration?.AlchoholQuestionaire === "") {
            return message.warning("Please fill the Proposal Form - Declaration and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === false && !ProposalTabs?.ProposerDetails) {
            return message.warning("Please fill the Proposal Form - Proposer Details and click on Next");
          } else if (ProposalTabs?.proposalStatus === "Login WIP - Proposal Draft") {
            if (isSupervisorApprovalRequired) {
              return message.warning("Please complete the All Proposal Form to proceed for Supervisor Approval");
            } else {
              return message.warning("Please complete the All Proposal Form to proceed for OTP Authentication");
            }
          } else if (isSupervisorApprovalRequired && (!ProposalTabs?.supervisorApproval || (ProposalTabs?.supervisorApproval?.status !== "Approved" && ProposalTabs?.supervisorApproval?.status !== "approved"))) {
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (isSupervisorApprovalRequired && (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") && !["Login WIP - OTP Authentication pending", "OTP Authentication Pending", "Pending OTP", "Login WIP - Payment Pending", "Payment Pending", "Login WIP - Mandate Pending", "Login WIP - e-SIR Pending", "e-SIR Pending"].includes(ProposalTabs?.proposalStatus)) {
            return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
          } else if (ProposalTabs?.OTPAuthStatus !== "SUCCESS") {
            return message.warning("Please complete OTP Authentication");
          } else if (ProposalTabs?.paymentOptions?.paymentStatus == "PENDING") {
            return message.warning("Payment is Pending");
          } else if (ProposalTabs?.proposalStatus === "Login WIP - e-SIR Pending") {
            return message.warning("Please complete ESIR for the proposal");
          } else {
            if (ProposalTabs?.subsequentPaymentMode === "enach") {
              let result = await axiosRequest.get(`user/enachCheck/${ProposalTabs._id}`);

              //console.log("check enach statsus", result);
              if (result?.proceedESIR === true) {
                return history.push("/finalSubmit");
              } else {
                return;
              }
            } else {
              return history.push("/finalSubmit");
            }
          }

        case "ProposalFormFilling":
          // In team view, allow navigation regardless of status
          if (globalTab === "team") {
            return history.push("/proposalFormFilling/EInsurance");
          }

          if (isBackNavigation && isSupervisorApproved) {
            return handleSupervisorApprovalReset(() =>
              history.push("/proposalFormFilling/EInsurance")
            );
          }
          if (isBackNavigation && alreadyResetSupervisorApproval) {
            return history.push("/proposalFormFilling/EInsurance");
          }

          if (Object.keys(ProposalTabs).length === 0) {
            return message.warning("Proposal is submitted. Kindly generate new BI.");
          } else if (!_proposalId) {
            return message.warning("Please Generate BI");
          } else if (ProposalTabs?.regenerateBi || !ProposalTabs?.biDisabled) {
            return message.warning("Please generate BI to proceed further.");
          } else if (!ProposalTabs?.leadId?.isKycStageCompleted) {
            return message.warning("Please complete KYC to proceed further.");
          } else if (ProposalTabs?.proposalStatus === "Supervisor Approval Pending" && ProposalTabs?.supervisorApproval?.status !== "Reconsidered") {
            if (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") {
              return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
            }
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (ProposalTabs?.proposalStatus === "Login successful - Login Successful") {
            return message.warning("Login for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (paymentStatus == "SUCCESS") {
            return message.warning("Payment for this proposal is sucessfuly completed. Returning to previous tab is no longer available.");
          } else if (ProposalTabs?.OTPAuthStatus === "SUCCESS") {
            return message.warning("OTP Authentication for this proposal is successfully completed. Returning to previous tab is no longer available.");
          }
          // else if (ProposalTabs?.documentUpload?.length == 0) {
          //   return message.warning("Please upload the Mandatory Docs");
          // }
          else if (hasEmptyUploads(ProposalTabs?.documentUpload)) {
            return message.warning("Please upload the Mandatory Docs");
          } else {
            return history.push("/proposalFormFilling/EInsurance");
          }

        case "uploaddocuments":
          // In team view, allow navigation regardless of status
          if (globalTab === "team") {
            return history.push("/uploaddoc/photograph_li");
          }

          if (isBackNavigation && isSupervisorApproved) {
            return handleSupervisorApprovalReset(() =>
              history.push("/uploaddoc/photograph_li")
            );
          }
          if (isBackNavigation && alreadyResetSupervisorApproval) {
            return history.push("/uploaddoc/photograph_li");
          }

          if (Object.keys(ProposalTabs).length === 0) {
            return message.warning("Proposal is submitted. Kindly generate new BI.");
          } else if (!_proposalId) {
            return message.warning("Please Generate BI");
          } else if (ProposalTabs?.regenerateBi || !ProposalTabs?.biDisabled) {
            return message.warning("Please generate BI to proceed further.");
          } else if (ProposalTabs?.proposalStatus === "Supervisor Approval Pending" && ProposalTabs?.supervisorApproval?.status !== "Reconsidered") {
            if (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") {
              return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
            }
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (ProposalTabs?.proposalStatus === "Login successful - Login Successful") {
            return message.warning("Login for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (paymentStatus == "SUCCESS") {
            return message.warning("Payment for this proposal is sucessfuly completed. Returning to previous tab is no longer available.");
          } else if (!ProposalTabs?.leadId?.isKycStageCompleted) {
            return message.warning("Please complete KYC to proceed further.");
          } else if (ProposalTabs?.OTPAuthStatus === "SUCCESS") {
            return message.warning("OTP Authentication for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else {
            return history.push("/uploaddoc/photograph_li");
          }

        case "uploaddynamicdocuments":
          // In team view, allow navigation regardless of status
          if (globalTab === "team") {
            if (_proposalId && ProposarAndLifeInsured) {
              return history.push("/uploaddynamicdoc/lifeInsured");
            } else if (_proposalId) {
              return history.push("/uploaddynamicdoc/proposer");
            }
          }

          if (isBackNavigation && isSupervisorApproved) {
            return handleSupervisorApprovalReset(() => {
              if (ProposarAndLifeInsured) {
                history.push("/uploaddynamicdoc/lifeInsured");
              } else {
                history.push("/uploaddynamicdoc/proposer");
              }
            });
          }
          if (isBackNavigation && alreadyResetSupervisorApproval) {
            if (ProposarAndLifeInsured) {
              return history.push("/uploaddynamicdoc/lifeInsured");
            } else {
              return history.push("/uploaddynamicdoc/proposer");
            }
          }

          if (Object.keys(ProposalTabs).length === 0) {
            return message.warning("Proposal is submitted. Kindly generate new BI.");
          } else if (!_proposalId) {
            return message.warning("Please Generate BI");
          } else if (ProposalTabs?.proposalStatus === "Login successful - Login Successful") {
            return message.warning("Login for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (paymentStatus == "SUCCESS") {
            return message.warning("Payment for this proposal is sucessfuly completed. Returning to previous tab is no longer available.");
          } else if (ProposalTabs?.regenerateBi || !ProposalTabs?.biDisabled) {
            return message.warning("Please generate BI to proceed further.");
          } else if (!ProposalTabs?.leadId?.isKycStageCompleted) {
            return message.warning("Please complete KYC to proceed further.");
          } else if (ProposalTabs?.proposalStatus === "Supervisor Approval Pending" && ProposalTabs?.supervisorApproval?.status !== "Reconsidered") {
            if (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") {
              return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
            }
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (ProposalTabs?.OTPAuthStatus === "SUCCESS") {
            return message.warning("OTP Authentication for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (hasEmptyUploads(ProposalTabs?.documentUpload)) {
            return message.warning("Please upload the Mandatory Docs");
          } else if (ProposalTabs?.elinsuranceAccountDetails == undefined) {
            return message.warning("Please fill the Proposal Form - EInsurance");
          } else if (ProposalTabs?.AboutCustomer == undefined) {
            return message.warning("Please fill the Proposal Form - About Customer and click on Next");
          } else if (lifeInsuredAge > 18 && ProposalTabs?.FinancialDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Financial Details and click on Next");
          } else if (ProposalTabs?.HealthDetailsSection.customerHeight === undefined || ProposalTabs?.HealthDetailsSection.customerHeight === "") {
            return message.warning("Please fill the Proposal Form - Health Details and click on Next");
          } else if (ProposalTabs?.PreviousPolicyDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Previous Policy Details and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === true && !ProposalTabs?.NominationDetails?.NomineeName) {
            return message.warning("Please fill the Proposal Form - Nomination Details and click on Next");
          } else if (ProposalTabs?.Declaration?.AlchoholQuestionaire === "") {
            return message.warning("Please fill the Proposal Form - Declaration and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === false && !ProposalTabs?.ProposerDetails) {
            return message.warning("Please fill the Proposal Form - Proposer Details and click on Next");
          } else if (_proposalId && ProposarAndLifeInsured) {
            return history.push("/uploaddynamicdoc/lifeInsured");
          } else if (_proposalId) {
            return history.push("/uploaddynamicdoc/proposer");
          }

        // case "lifeInsuredPhotograpgh":
        //   return history.push("/uploaddoc/photograph_li")

        case "supervisorApproval":
          // In team view, allow navigation regardless of status
           const selectedTeamMember = stoageGetter("teamMemberId");
          const isSelfView = login_user_data?.id === selectedTeamMember ? true : false;

          if (globalTab === "team" && ProposalTabs?.channelCode?.supervisorApprovalFlag && !isSelfView) {
            return history.push("/supervisorApprovalManager");
          }

          if (Object.keys(ProposalTabs).length === 0) {
            return message.warning("Proposal is submitted. Kindly generate new BI.");
          } else if (!_proposalId) {
            return message.warning("Please Generate BI");
          } else if (ProposalTabs?.regenerateBi || !ProposalTabs?.biDisabled) {
            return message.warning("Please generate BI to proceed further.");
          } else if (!ProposalTabs?.leadId?.isKycStageCompleted) {
            return message.warning("Please complete KYC to proceed further.");
          } else if (hasEmptyUploads(ProposalTabs?.documentUpload)) {
            return message.warning("Please upload the Mandatory Docs");
          } else if (ProposalTabs?.elinsuranceAccountDetails == undefined) {
            return message.warning("Please fill the Proposal Form - EInsurance");
          } else if (ProposalTabs?.AboutCustomer == undefined) {
            return message.warning("Please fill the Proposal Form - About Customer and click on Next");
          } else if (lifeInsuredAge > 18 && ProposalTabs?.FinancialDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Financial Details and click on Next");
          } else if (ProposalTabs?.HealthDetailsSection.customerHeight === undefined || ProposalTabs?.HealthDetailsSection.customerHeight === "") {
            return message.warning("Please fill the Proposal Form - Health Details and click on Next");
          } else if (ProposalTabs?.PreviousPolicyDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Previous Policy Details and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === true && !ProposalTabs?.NominationDetails?.NomineeName) {
            return message.warning("Please fill the Proposal Form - Nomination Details and click on Next");
          } else if (ProposalTabs?.Declaration?.AlchoholQuestionaire === "") {
            return message.warning("Please fill the Proposal Form - Declaration and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === false && !ProposalTabs?.ProposerDetails) {
            return message.warning("Please fill the Proposal Form - Proposer Details and click on Next");
          } else if (ProposalTabs?.proposalStatus === "Login WIP - Proposal Draft") {
            return message.warning("Please complete the All Proposal Form to proceed for Supervisor Approval");
          } else if (ProposalTabs?.proposalStatus === "Login successful - Login Successful") {
            return message.warning("Login for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (paymentStatus == "SUCCESS") {
            return message.warning("Payment for this proposal is sucessfuly completed. Returning to previous tab is no longer available.");
          } else if (ProposalTabs?.OTPAuthStatus === "SUCCESS") {
            return message.warning("OTP Authentication for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (isSupervisorApprovalRequired) {
            return history.push("/supervisorApproval");
          } else {
            console.log("not allowed to access supervisors approval panel")
          }

        case "oTPAuthentication":
          // In team view, allow navigation regardless of status
          if (globalTab === "team") {
            return history.push("/OTPAuthentication");
          }

          if (Object.keys(ProposalTabs).length === 0) {
            return message.warning("Proposal is submitted. Kindly generate new BI.");
          } else if (!_proposalId) {
            return message.warning("Please Generate BI");
          } else if (ProposalTabs?.proposalStatus === "Login successful - Login Successful") {
            return message.warning("Login for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (ProposalTabs?.regenerateBi || !ProposalTabs?.biDisabled) {
            return message.warning("Please generate BI to proceed further.");
          } else if (ProposalTabs?.proposalStatus === "Supervisor Approval Pending") {
            if (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") {
              return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
            }
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (paymentStatus == "SUCCESS") {
            return message.warning("Payment for this proposal is sucessfuly completed. Returning to previous tab is no longer available.");
          } else if (ProposalTabs?.OTPAuthStatus === "SUCCESS") {
            return message.warning("OTP Authentication for this proposal is successfully completed. Returning to previous tab is no longer available.");
          } else if (!ProposalTabs?.leadId?.isKycStageCompleted) {
            return message.warning("Please complete KYC to proceed further.");
          } else if (hasEmptyUploads(ProposalTabs?.documentUpload)) {
            return message.warning("Please upload the Mandatory Docs");
          } else if (ProposalTabs?.elinsuranceAccountDetails == undefined) {
            return message.warning("Please fill the Proposal Form - EInsurance and click on Next");
          } else if (ProposalTabs?.AboutCustomer == undefined) {
            return message.warning("Please fill the Proposal Form - About Customer and click on Next");
          } else if (lifeInsuredAge > 18 && ProposalTabs?.FinancialDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Financial Details and click on Next");
          } else if (ProposalTabs?.HealthDetailsSection.customerHeight === undefined || ProposalTabs?.HealthDetailsSection.customerHeight === "") {
            return message.warning("Please fill the Proposal Form - Health Details and click on Next");
          } else if (ProposalTabs?.PreviousPolicyDetails == undefined) {
            return message.warning("Please fill the Proposal Form - Previous Policy Details and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === true && !ProposalTabs?.NominationDetails?.NomineeName) {
            return message.warning("Please fill the Proposal Form - Nomination Details and click on Next");
          } else if (ProposalTabs?.Declaration?.AlchoholQuestionaire === "") {
            return message.warning("Please fill the Proposal Form - Declaration and click on Next");
          } else if (ProposalTabs?.benefitIllustration?.SameProposer === false && !ProposalTabs?.ProposerDetails) {
            return message.warning("Please fill the Proposal Form - Proposer Details and click on Next");
            // }  else if (ProposalTabs?.OTPAuthStatus !== "SUCCESS") {
            //   return message.warning("Please complete OTP Authentication");
            // } else if (ProposalTabs?.paymentOptions?.paymentStatus == "PENDING") {
            //   return message.warning("Payment is Pending");
            // } else if (ProposalTabs?.mandateStatus === "NA") {
            //   return message.warning("Mandate is Pending");
          } else if (ProposalTabs?.proposalStatus === "Login WIP - Proposal Draft") {
            if (isSupervisorApprovalRequired) {
              return message.warning("Please complete the All Proposal Form to proceed for Supervisor Approval");
            } else {
              return message.warning("Please complete the All Proposal Form to proceed for OTP Authentication");
            }
          } else if (isSupervisorApprovalRequired && (!ProposalTabs?.supervisorApproval || (ProposalTabs?.supervisorApproval?.status !== "Approved" && ProposalTabs?.supervisorApproval?.status !== "approved"))) {
            return message.warning("Supervisor review is pending. Please contact your supervisor to proceed.");
          } else if (isSupervisorApprovalRequired && (ProposalTabs?.supervisorApproval?.status === "Approved" || ProposalTabs?.supervisorApproval?.status === "approved") && !["Login WIP - OTP Authentication pending", "OTP Authentication Pending", "Pending OTP", "Login WIP - Payment Pending", "Payment Pending", "Login WIP - Mandate Pending", "Login WIP - e-SIR Pending", "e-SIR Pending"].includes(ProposalTabs?.proposalStatus)) {
            return message.success("Supervisor approval received. Please click \"Proceed\" in the Supervisor Approval tab to continue.");
          } else {
            return history.push("/OTPAuthentication");
          }
        case "ApplicationAll":
          return history.push("/applications/all");
        case "WIPApplication":
          return history.push("/applications/wip");
        case "PendingApplication":
          return history.push("/applications/pending");
        case "IssuedApplication":
          return history.push("/applications/issued");
        case "RTSApplication":
          return history.push("/applications/rts");
        case "RejectedApplication":
          return history.push("/applications/rejected");
        // case "prepaymentreview": return history.push('/master/prepaymentreview');
        // case "paymentoptions": return history.push('/master/paymentoptions');
        // case "uploaddocuments": return history.push('/master/uploaddocuments');
        // case "proposalhistory": return history.push('/master/proposalhistory');
        default:
          return history.push("/home");
      }
    }
  };

  const setFilterData = () => {
    //  const { id } = stoageGetter("user");
    //  dispatch(actions.fetchAllLeads(id, 'all', 1));
    //  dispatch({ type: "CURRENT_UPDATING_TAB", action: "all" });
    if (leadtype == "LSQ") {
      // ////console.log("upsideDispatch------>")
      setLoader(true);
      dispatch(actions.fetchLeadType(""));
      setLoader(false);
      // ////console.log("downDispatch------>")
    } else if (leadtype == "Self Sourced") {
      setLoader(true);
      dispatch(actions.fetchLeadType(""));
      setLoader(false);
    }
    setLoader(false);
    getDataForOpen("all");
  };

  //  const setFilterDataForSelf = () =>{
  //   getDataForOpen("all");
  //  }

  // Determine current stage for Proposal header to control navigation in team view
  const isProposalHeader = header === "Proposal";
  const tabOrder = [
    "benefitIllustrator",
    "kycDetails",
    "uploaddocuments",
    "ProposalFormFilling",
    "uploaddynamicdocuments",
    "supervisorApproval",
    "oTPAuthentication",
    "payments",
    "esir",
    "finalSubmit",
  ];
  const statusToTabIndex = {
    "Login WIP - Proposal Draft": tabOrder.indexOf("ProposalFormFilling"),
    "Login WIP - OTP Authentication pending": tabOrder.indexOf("oTPAuthentication"),
    "OTP Authentication Pending": tabOrder.indexOf("oTPAuthentication"),
    "Pending OTP": tabOrder.indexOf("oTPAuthentication"),
    "Login WIP - Payment Pending": tabOrder.indexOf("payments"),
    "Payment Pending": tabOrder.indexOf("payments"),
    "Login WIP - Mandate Pending": tabOrder.indexOf("payments"),
    "Login WIP - e-SIR Pending": tabOrder.indexOf("esir"),
    "e-SIR Pending": tabOrder.indexOf("esir"),
    "Login WIP - Document Upload Pending": tabOrder.indexOf("uploaddocuments"),
    "Document Upload Pending": tabOrder.indexOf("uploaddocuments"),
    "Login WIP - Dynamic Document Upload Pending": tabOrder.indexOf("uploaddynamicdocuments"),
    "Dynamic Document Upload Pending": tabOrder.indexOf("uploaddynamicdocuments"),
    "Supervisor Approval Pending": tabOrder.indexOf("supervisorApproval"),
    "Login successful - Login Successful": tabOrder.indexOf("finalSubmit"),
  };
  const currentTabIndex = isProposalHeader ? (statusToTabIndex[proposalStatus] ?? tabOrder.indexOf("ProposalFormFilling")) : -1;

  // Handle back navigation for team view
  const handleBackNavigation = () => {
    history.goBack();
  };
  // Strict view-only: In team view on Proposal flow, block all interactions on page content
  useEffect(() => {
    const isSupervisorPage =
      currentLocation.pathname === "/supervisorApprovalManager";

    const enableViewOnly = isProposalHeader && globalTab === "team" && !isSupervisorPage;
    const body = document?.body;
    //const proposalContainer = document.querySelector(".proposal-content");
    if (!body) return;
    if (enableViewOnly) {
      body.classList.add("view-only-mode");
    } else {
      body.classList.remove("view-only-mode");
    }
    return () => {
      body.classList.remove("view-only-mode");
    };
  }, [isProposalHeader, globalTab, currentLocation]);

  let tabPane = [];
  // if (tabMenu && !_.isEmpty(tabMenu)) {
  //   tabPane = _.map(tabMenu, (value, id) => {
  //     return <TabPane key={value.id} tab={value.value}></TabPane>;
  //   });
  //   // console.warn("tabPane", tabPane)
  // }

  if (tabMenu && !_?.isEmpty(tabMenu)) {
    tabPane = _?.map(tabMenu, (value, id) => {
      const valueIndex = tabOrder.indexOf(value.id);
      const disableFuture = isProposalHeader && globalTab === "team" && valueIndex !== -1 && currentTabIndex !== -1 && valueIndex > currentTabIndex;
      return (
        <TabPane
          key={value.id}
          tab={
            value.value +
            " " +
            (location.pathname === "/leadMaster/all_leads" ||
              location.pathname === "/leadMaster/notInterested" ||
              location.pathname === "/leadMaster/openlead" ||
              location.pathname === "/leadMaster/notContactable" ||
              location.pathname === "/leadMaster/wip" ||
              location.pathname === "/leadMaster/closed"
              ? currentActiveTab === "team"
                ? `(${count1[id] === undefined || count1[id] === null ? "0" : count1[id]})`
                : `(${count[id] === undefined ? "0" : count[id]})`
              : "")
          }
          disabled={disableFuture}
        ></TabPane>
      );
    });
    //  ////console.log("tabPane", tabPane) (currentActiveTab === 'team' || activeKey === 'all' ? count1 : `(${count[id]})`)
  }

  const [width, setWidth] = useState(window.innerWidth);
  const breakpoint = 620;

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);

    // Return a function from the effect that removes the event listener
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [width]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  // ---------------------------filter by proposal status---------------------------------
  const handleStatusFilter = (value) => {
    setFilterByStatus(value);
    console.log("status-filter-event ===", value);
  };

  useEffect(() => {
    if (filterByStatus) {
      handleProposalStatusFilter(filterByStatus);
    }
    if (filterByStatus == "All") {
      handleProposalStatusFilter("");
    }
  }, [filterByStatus]);

  const handleAllowClear = () => {
    handleProposalStatusFilter("");
  };

  const statusOptions = [
    { label: "All", value: "All", currentTab: "WIPApplication", defaultTab: "all" },
    { label: "Login WIP - Proposal Draft", value: "Login WIP - Proposal Draft", currentTab: "WIPApplication", defaultTab: "all" },
    { label: "Supervisor Approval Pending", value: "Supervisor Approval Pending", currentTab: "WIPApplication", defaultTab: "all" },
    { label: "Login WIP - OTP Authentication Pending", value: "Login WIP - OTP Authentication pending", currentTab: "WIPApplication", defaultTab: "all" },
    { label: "Login WIP - Payment Pending", value: "Login WIP - Payment Pending", currentTab: "WIPApplication", defaultTab: "all" },
    { label: "Login WIP - Mandate Pending", value: "Login WIP - Mandate Pending", currentTab: "WIPApplication", defaultTab: "all" },
    { label: "Login WIP - e-SIR Pending", value: "Login WIP - e-SIR Pending", currentTab: "WIPApplication", defaultTab: "all" },

    { label: "All", value: "All", currentTab: "PendingApplication" },
    { label: "Login Successful", value: "Login Successful", currentTab: "PendingApplication", defaultTab: "all" },

    { label: "All", value: "All", currentTab: "IssuedApplication" },
    { label: "Issued", value: "Issued", currentTab: "IssuedApplication", defaultTab: "all" },
    { label: "Contract Proposal", value: "Contract Proposal", currentTab: "IssuedApplication", defaultTab: "all" },
    { label: "Contract Declined", value: "Contract Declined", currentTab: "IssuedApplication", defaultTab: "all" },
    { label: "Contract Withdrawn", value: "Contract Withdrawn", currentTab: "IssuedApplication", defaultTab: "all" },
    { label: "Contract Postponed", value: "Contract Postponed", currentTab: "IssuedApplication", defaultTab: "all" },
    { label: "Contract Rejected", value: "Contract Rejected", currentTab: "IssuedApplication", defaultTab: "all" },
    { label: "RTS Submitted", value: "RTS Submitted", currentTab: "IssuedApplication", defaultTab: "all" },

    { label: "All", value: "All", currentTab: "RTSApplication" },
    { label: "RTS Pending", value: "RTS Pending", currentTab: "RTSApplication", defaultTab: "all" },
    { label: "RTS Submitted", value: "RTS Submitted", currentTab: "RTSApplication", defaultTab: "all" },
  ];

  // ---------------------------filter by proposal status end---------------------------------

  return (
    <>
      {/* <p className="all_tabss">0</p> */}
      {/* {activeTab === 'open' ? <p className="all_tabss_open">{totalLeads}</p> : null} */}
      <>
        <Loader formloader={loader} />
      </>

      {/* {location.pathname === "/leadMaster/all_leads" ? (
        <>
          <div style={{ position: "absolute", marginTop: "11rem", marginLeft: "4rem" }}>
            {leadtype == "LSQ" || leadtype == "Self Sourced" ? (
              <Tag closable color="rgb(0 172 193)" backgroundColor="rgb(1 180 187)" onClose={setFilterData}>
                {leadtype}
              </Tag>
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        ""
      )} */}

      {/* <div style={{position: 'absolute',
      marginTop: '11rem',
      marginLeft: '4rem'}}>
      {leadtype == "Self Sourced" ?
        <Tag
            closable
            color="rgb(0 172 193)"
            backgroundColor='rgb(1 180 187)'
            // onClose={setFilterDataForSelf}
          >
            {leadtype}
          </Tag>
            : "" } 
    </div> */}

      {width > breakpoint ? (
        <div className="header-img-tabs tabsStyle">
          {/* back button for Proposal header in team view */}
          {/* {header === "Proposal" && globalTab === "team" && (
            <div className="back-button-container">
              <button
                onClick={handleBackNavigation}
                className="back-button"
              >
                <ArrowLeftOutlined />
                Back
              </button>
            </div>
          )} */}
          <div>
            <div>
              <p className="header-title-tab">
                {isProposalHeader ? (
                  <>
                    {header} {policyId && <span style={{ fontSize: "22px" }}>: {policyId}</span>}
                  </>
                ) : (
                  header
                )}
              </p>
            </div>
            {proposalTeamUser ?
              <div style={{ width: header === "Applications" ? "93vw" : "100%" }}>
                <Row justify="space-between" align="baseline">
                  <Col >
                    <Tabs tabBarGutter={5} centered={false} type="card" onTabClick={handler} size="small" activeKey={activeKey} className="main-lead-tabs">
                      {tabPane}
                    </Tabs>
                  </Col>
                  {header === "Applications" ? (
                    // <Select
                    //   value={filterByStatus}
                    //   className="status_select"
                    //   size="medium"
                    //   onChange={handleStatusFilter}
                    //   onClear={handleAllowClear}
                    //   allowClear
                    //   style={{
                    //     width: "250px",
                    //     display: "flex",
                    //     borderRadius: "5px",
                    //     alignItems: "baseline",
                    //     boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px",
                    //     height: "fit-content",
                    //     borderRadius: 16,
                    //   }}
                    //   placeholder="Filter By Status"
                    // >
                    //   {statusOptions
                    //     ?.filter((item) => item?.currentTab === activeKey)
                    //     .map((item) => (
                    //       <Select.Option key={item.value}>{item.label}</Select.Option>
                    //     ))}
                    // </Select>
                    <Select
                      value={filterByStatus}
                      className="status_select"
                      size="medium"
                      onChange={handleStatusFilter}
                      // onClear={handleAllowClear}
                      // allowClear
                      style={{
                        width: "250px",
                        display: "flex",
                        borderRadius: "5px",
                        alignItems: "baseline",
                        boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px",
                        height: "fit-content",
                        borderRadius: 16,
                      }}
                      placeholder="Filter By Status"
                    >
                      {statusOptions
                        ?.filter((item) => (activeKey === "ApplicationAll" ? item.defaultTab === "all" : item.currentTab === activeKey))
                        .map((item) => (
                          <Select.Option key={item.value}>{item.label}</Select.Option>
                        ))}
                    </Select>
                  ) : null}
                  {header === "Applications" ? (
                    <Col>
                      {" "}
                      <Input
                        value={proposalNumberSearch}
                        onChange={(e) => handleProposalNumber(e.target.value)}
                        onPressEnter={handleSearchProposalNumber}
                        suffix={suffix}
                        placeholder="Search Proposal Number"
                        onInput={toInputUppercase}
                        style={{
                          // marginTop: "-3vh",
                          width: 250,
                          borderRadius: "5px",
                          boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                          padding: "5px 10px",
                          border: "1px solid B7D6FF",
                        }}
                      />
                    </Col>
                  ) : null}
                </Row>
              </div>
              : null
            }
          </div>

          {header === "Applications" && (
            <div style={{ position: 'absolute', right: '2rem', top: '5rem' }} className="round-card-main-Tab">
              {/* Refresh Button */}
              <div className="round-card-main-Tab" style={{ marginRight: '0.8rem', flex: 'none' }}>
                <figure
                  className="round-cards-rts"
                  onClick={get_live_rts_data}
                  role="button"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      get_live_rts_data();
                    }
                  }}
                  tabIndex={0}
                >
                  <div style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <SyncOutlined style={{ fontSize: "20px", color: "#565758", marginTop: "-3px" }} />
                  </div>
                  <figcaption className="card-caption">RTS</figcaption>
                </figure>
              </div>

              {(checkAgent() === false || checkPartnerUser()) && (userTreeData?.reporting_users?.length > 0 || userTreeData?.reporting_managers?.length > 0) && (
                <>
                  <div className="round-card-main-Tab">
                    {currentActiveTab === "self" && allocateBtnStatus ? (
                      ""
                    ) : (
                      <>
                        <figure
                          className={currentActiveTab === "team" ? "round-cards1-active" : "round-cards1"}
                          onClick={() => handleChangeTab("team")}
                          key={"team"}
                          role="button"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              // Checks if Enter is pressed
                              handleChangeTab("team");
                            }
                          }}
                        >
                          {" "}
                          <figcaption className="card-caption">Team</figcaption>{" "}
                        </figure>
                      </>
                    )}
                  </div>

                  <div className="round-card-main-Tab">
                    {currentActiveTab === "team" && allocateBtnStatus ? (
                      ""
                    ) : (
                      <figure
                        className={currentActiveTab === "self" ? "round-cards2-active" : "round-cards2"}
                        onClick={() => handleChangeTab("self")}
                        key={"self"}
                        role="button"
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            // Checks if Enter is pressed
                            handleChangeTab("self");
                          }
                        }}
                      >
                        {" "}
                        <figcaption className="card-caption">Self</figcaption>{" "}
                      </figure>
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          <div style={{ position: 'absolute', right: '2rem', top: '5rem' }} className="round-card-main-Tab">
            {/* <p>{tabPane.key}</p> */}
            {tabPane.key === activeKey ? (
              <div className="round-card-main-Tab">
                {(checkAgent() === false || checkPartnerUser()) && (userTreeData?.reporting_users?.length > 0 || userTreeData?.reporting_managers?.length > 0) && (
                  <>
                    <div className="round-card-main-Tab">
                      {currentActiveTab === "self" && allocateBtnStatus ? (
                        ""
                      ) : (
                        <>
                          <figure
                            className={currentActiveTab === "team" ? "round-cards1-active" : "round-cards1"}
                            onClick={() => handleChangeTab("team")}
                            key={"team"}
                            role="button"
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                // Checks if Enter is pressed
                                handleChangeTab("team");
                              }
                            }}
                          >
                            {" "}
                            <figcaption className="card-caption">Team</figcaption>{" "}
                          </figure>
                        </>
                      )}
                    </div>

                    <div className="round-card-main-Tab">
                      {currentActiveTab === "team" && allocateBtnStatus ? (
                        ""
                      ) : (
                        <figure
                          className={currentActiveTab === "self" ? "round-cards2-active" : "round-cards2"}
                          onClick={() => handleChangeTab("self")}
                          key={"self"}
                          role="button"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              // Checks if Enter is pressed
                              handleChangeTab("self");
                            }
                          }}
                        >
                          {" "}
                          <figcaption className="card-caption">Self</figcaption>{" "}
                        </figure>
                      )}
                    </div>

                    <AllocateModalShow />
                  </>
                )}
                <GlobalFilters show={show} onHide={handleClose} handleShow={handleShow} setShow={setShow} subSourceArr={subSource} />
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        // FOR MOBILE WEB
        <div className="tabsStyle" style={{ display: "flex", flexDirection: "Column" }}>
          {/* Back button for Proposal header in team view (mobile) */}
          {/* {header === "Proposal" && globalTab === "team" && (
            <div className="back-button-mobile-container">
              <button
                className="Back-button"
                onClick={handleBackNavigation}
                
              >
               <ArrowLeftOutlined />
      Back

              </button>
            </div>
          )} */}
          {isProposalHeader && policyId && (
            <div>
              <p style={{
                fontSize: "1rem",
                fontWeight: "600",
                paddingLeft: "5%",
                paddingBottom: "1.5%",
                fontFamily: "Lato', sans-serif"
              }}>
                {header}{policyId && <span >: {policyId}</span>}
              </p>
            </div>
          )}

          <div>
            <Tabs
              tabBarGutter={20}
              centered={false}
              onTabClick={handler}
              size="small"
              activeKey={activeKey}
              style={{
                backgroundColor: "#red",
                boxShadow: "0px 1px 10px 0px #0000003d",
              }}
            >
              {tabPane}
            </Tabs>
          </div>
          {/* <GlobalFilters style={{ margin: "10px 0px" }} show={show} onHide={handleClose} handleShow={handleShow} setShow={setShow} subSourceArr={subSource} /> */}
          {header === "Applications" ? (
            <div>
              <Row style={{ margin: 0 }} gutter={[16, 8]} justify={"center"}>
                <Col style={{ width: "100%" }} span={24}>
                  <Input
                    value={proposalNumberSearch}
                    onChange={(e) => handleProposalNumber(e.target.value)}
                    onPressEnter={handleSearchProposalNumber}
                    suffix={suffix}
                    placeholder="Search Proposal Number"
                    onInput={toInputUppercase}
                    style={{
                      marginTop: "4%",
                      width: "100%",
                      // marginLeft: "5%",
                      borderRadius: "5px",
                      boxShadow: "0 0 5px rgba(0,0,0,0.1)",
                      padding: "5px 10px",
                      border: "1px solid B7D6FF",
                    }}
                  />
                </Col>
                <Col style={{ width: "100%" }} span={24}>
                  <Select
                    value={filterByStatus}
                    className="status_select"
                    size="medium"
                    onChange={handleStatusFilter}
                    // onClear={handleAllowClear}
                    // allowClear
                    style={{
                      width: "100%",
                      display: "flex",
                      borderRadius: "5px",
                      alignItems: "baseline",
                      boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px",
                      height: "fit-content",
                      borderRadius: 16,
                    }}
                    placeholder="Filter By Status"
                  >
                    {statusOptions
                      ?.filter((item) => (activeKey === "ApplicationAll" ? item.defaultTab === "all" : item.currentTab === activeKey))
                      .map((item) => (
                        <Select.Option key={item.value}>{item.label}</Select.Option>
                      ))}
                  </Select>
                </Col>
              </Row>
            </div>
          ) : null}
          {header === "Lead" || header === "Applications" && (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "16px",
                gap: "10px",
                flexWrap: "wrap"
              }}
            >
              <div style={{ display: "flex", gap: "10px", width: "100%" }}>
                {(checkAgent() === false || checkPartnerUser()) && (userTreeData?.reporting_users?.length > 0 || userTreeData?.reporting_managers?.length > 0) && (
                  <>
                    {currentActiveTab === "team" && allocateBtnStatus ? (
                      <div style={{ width: "100%" }} />
                    ) : (

                      <button onClick={() => handleChangeTab("self")} key={"self"} className={currentActiveTab === "self" ? "active_tabs_button" : "tabs_button"} style={{ flex: 1 }}>
                        <img src={currentActiveTab === "self" ? person_white : person_black} className="person" alt="person_png" /> Self
                      </button>

                    )}

                    {currentActiveTab === "self" && allocateBtnStatus ? (
                      <div style={{ width: "100%" }} />
                    ) : (

                      <button onClick={() => handleChangeTab("team")} key={"team"} className={currentActiveTab === "team" ? "active_tabs_button" : "tabs_button"} style={{ flex: 1 }}>
                        <img src={currentActiveTab === "team" ? group_white : group_black} className="group" alt="person_png" /> Team
                      </button>

                    )}
                  </>
                )}

                {/* RTS Button Mobile */}
                <button
                  onClick={get_live_rts_data}
                  className="tabs_button"
                  style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}
                >
                  <SyncOutlined style={{ fontSize: "16px" }} /> RTS
                </button>

                {/* {header === "Applications" && <AllocateModalShow />} */}
              </div>
              {header === "Lead" && (

                <GlobalFilters show={show} onHide={handleClose} handleShow={handleShow} setShow={setShow} subSourceArr={subSource} />
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
}; export default Tab;